<template>
  <div v-if="cerfa">
    <!-- AMENAGEMENT D'ACCES -->
    <div>
      <div class="header">
        <h3>Aménagement d'accès</h3>
      </div>
      <div class="block-content">
        <div class="form-group">
          <b-row>
            <table class="table-front">
              <tr>
                <th class="no-border"></th>
                <th>Pose de clôtures</th>
                <th>Pose de portail (portillon)</th>
                <th>Plantations</th>
              </tr>
              <tr>
                <td>
                  <label class="control-label no-padding">
                    <span v-b-tooltip.hover title="Pose de clôtures à l'alignement / Pose de portail (portillon) à l'alignement / Plantations à l'alignement">
                      <font-awesome-icon icon="question-circle"></font-awesome-icon>
                    </span>
                    A l'alignement
                  </label>
                </td>
                <td>
                  <b-form-radio-group
                    class="marginLeft-15"
                    v-model="cerfa.installationFencesAlignment"
                    :options="options"
                  ></b-form-radio-group>
                </td>
                <td>
                  <b-form-radio-group
                    class="marginLeft-15"
                    v-model="cerfa.installationGateAlignment"
                    :options="options"
                  ></b-form-radio-group>
                </td>
                <td>
                  <b-form-radio-group
                    class="marginLeft-15"
                    v-model="cerfa.installationPlantationAlignment"
                    :options="options"
                  ></b-form-radio-group>
                </td>
              </tr>
              <tr>
                <td>
                  <label class="control-label no-padding">
                    <span v-b-tooltip.hover title="Pose de clôtures en retrait de l'alignement / Pose de portail (portillon) en retrait de l'alignement / Plantations en retrait de l'alignement">
                      <font-awesome-icon icon="question-circle"></font-awesome-icon>
                    </span>
                    En retrait de l'alignement
                  </label>
                </td>
                <td>
                  <b-row class="no-margin">
                    <b-col lg="9" md="8" sm="12" cols="12">
                      <b-form-input
                        type="number"
                        step="0.01"
                        min="0.00"
                        max="1000.00"
                        v-model="cerfa.installationFencesBackAlignment"
                        class="form-control send-api"
                        placeholder="Clôture"
                      />
                    </b-col>
                    <b-col lg="3" md="4" sm="12" cols="12" class="text-center">
                      <div class="control-label font-normal">m</div>
                    </b-col>
                  </b-row>
                </td>
                <td>
                  <b-row class="no-margin">
                    <b-col lg="9" md="8" sm="12" cols="12">
                      <b-form-input
                        type="number"
                        step="0.01"
                        min="0.00"
                        max="1000.00"
                        v-model="cerfa.installationGateBackAlignment"
                        class="form-control send-api"
                        placeholder="Portail"
                      />
                    </b-col>
                    <b-col lg="3" md="4" sm="12" cols="12" class="text-center">
                      <div class="control-label font-normal">m</div>
                    </b-col>
                  </b-row>
                </td>
                <td>
                  <b-row class="no-margin">
                    <b-col lg="9" md="8" sm="12" cols="12">
                      <b-form-input
                        type="number"
                        step="0.01"
                        min="0.00"
                        max="1000.00"
                        v-model="cerfa.installationPlantationBackAlignment"
                        class="form-control send-api"
                        placeholder="Plantations"
                      />
                    </b-col>
                    <b-col lg="3" md="4" sm="12" cols="12" class="text-center">
                      <div class="control-label font-normal">m</div>
                    </b-col>
                  </b-row>
                </td>
              </tr>
              <tr>
                <td colspan="4" class="text-center"></td>
              </tr>
            </table>

            <b-col
              xl="10"
              lg="9"
              md="9"
              sm="12"
              cols="12"
              class="form-with-label"
            >
            </b-col>
            <b-col xl="3" lg="3" md="4" sm="12" cols="12" class="no-padding">
              <label class="control-label">Franchissement de fossé :</label>
            </b-col>

            <b-col
              xl="9"
              lg="9"
              md="8"
              sm="12"
              cols="12"
              class="form-with-label"
            >
              <b-form-radio-group
                v-model="cerfa.ditchCrossing"
                :options="fosse"
              ></b-form-radio-group>
            </b-col>
          </b-row>

          <b-row class="no-margin" v-if="cerfa.ditchCrossing === true">
            <b-col xl="6" lg="12" md="12" sm="12" cols="12" class="no-padding">
              <b-row>
                <b-col
                  xl="6"
                  lg="4"
                  md="4"
                  sm="12"
                  cols="12"
                  class="no-padding"
                >
                  <label class="control-label">
                    <span v-b-tooltip.hover title="Saisir un nombre entier positif">
                      <font-awesome-icon icon="question-circle"></font-awesome-icon>
                    </span>
                    Diamètre du tuyau :
                  </label>
                </b-col>
                <b-col xl="4" lg="4" md="4" sm="12" cols="12">
                  <b-form-input
                    type="number"
                    step="1"
                    min="0.00"
                    max="1000.00"
                    v-model="cerfa.pipeDiameter"
                    required
                    class="form-control send-api"
                  />
                </b-col>
                <b-col
                  xl="2"
                  lg="4"
                  md="4"
                  sm="12"
                  cols="12"
                  class="no-padding"
                >
                  <div class="control-label font-normal text-left">mm</div>
                </b-col>
              </b-row>
            </b-col>
            <b-col xl="6" lg="12" md="12" sm="12" cols="12" class="no-padding">
              <b-row>
                <b-col
                  xl="6"
                  lg="4"
                  md="4"
                  sm="12"
                  cols="12"
                  class="no-padding"
                >
                  <label class="control-label">
                    <span v-b-tooltip.hover title="Saisir un nombre entier positif">
                      <font-awesome-icon icon="question-circle"></font-awesome-icon>
                    </span>
                    Longueur :
                  </label>
                </b-col>
                <b-col xl="4" lg="4" md="4" sm="12" cols="12">
                  <b-form-input
                    type="number"
                    v-model="cerfa.pipeLength"
                    required
                    class="form-control send-api"
                  />
                </b-col>
                <b-col
                  xl="2"
                  lg="4"
                  md="4"
                  sm="12"
                  cols="12"
                  class="no-padding"
                >
                  <div class="control-label font-normal text-left">m</div>
                </b-col>
              </b-row>
            </b-col>
            <b-col xl="6" lg="12" md="12" sm="12" cols="12" class="no-padding">
              <b-row>
                <b-col
                  xl="6"
                  lg="4"
                  md="4"
                  sm="12"
                  cols="12"
                  class="no-padding"
                >
                  <label class="control-label">
                    <span v-b-tooltip.hover title="Saisir un nombre entier positif">
                      <font-awesome-icon icon="question-circle"></font-awesome-icon>
                    </span>
                    Distance par rapport à l'axe de la chaussée :
                  </label
                  >
                </b-col>
                <b-col xl="4" lg="4" md="4" sm="12" cols="12">
                  <b-form-input
                    type="number"
                    v-model="cerfa.distanceFromRoad"
                    class="form-control send-api"
                  />
                </b-col>
                <b-col
                  xl="2"
                  lg="4"
                  md="4"
                  sm="12"
                  cols="12"
                  class="no-padding"
                >
                  <div class="control-label font-normal text-left">m</div>
                </b-col>
              </b-row>
            </b-col>
            <b-col xl="6" lg="12" md="12" sm="12" cols="12" class="no-padding">
              <b-row>
                <b-col
                  xl="6"
                  lg="4"
                  md="4"
                  sm="12"
                  cols="12"
                  class="no-padding"
                >
                  <label class="control-label">
                    <span v-b-tooltip.hover title="Aménagement d'accès : nature du tuyau">
                      <font-awesome-icon icon="question-circle"></font-awesome-icon>
                    </span>
                    Nature du tuyau :
                  </label>
                </b-col>
                <b-col xl="6" lg="4" md="4" sm="12" cols="12">
                  <b-form-input
                    v-model="cerfa.typePipe"
                    class="form-control send-api"
                  />
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <b-row class="no-margin" v-else-if="cerfa.ditchCrossing === false">
            <b-col xl="3" lg="4" md="4" sm="12" cols="12" class="no-padding">
              <label class="control-label">
                <span v-b-tooltip.hover title="Saisir un nombre entier positif">
                  <font-awesome-icon icon="question-circle"></font-awesome-icon>
                </span>
                Largueur de l'aménagement :
              </label>
            </b-col>
            <b-col xl="4" lg="4" md="4" sm="12" cols="12">
              <b-form-input
                type="number"
                v-model="cerfa.layoutWidth"
                class="form-control send-api"
              />
            </b-col>
            <b-col xl="5" lg="4" md="4" sm="12" cols="12" class="no-padding">
              <div class="control-label font-normal text-left">m</div>
            </b-col>
          </b-row>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vuex from "vuex";
export default {
  name: "NatureTravauxD14023",
  props: ["value"],
  methods: {
    ...Vuex.mapActions("Cerfa", ["setCerfa14023"]),
  },
  computed: {
    ...Vuex.mapGetters("Cerfa", ["cerfa14023"]),
    cerfa: {
      get: function() {
        return this.cerfa14023;
      },
      set: function(newValue) {
        this.setCerfa14023(newValue);
      },
    },
    parkingNature: {
      get() {
        if (this.cerfa.parkingNature == null) return [];
        else return this.cerfa.parkingNature.split(",");
      },
      set(value) {
        this.cerfa.parkingNature = value.join(",");
      },
    },
    themes: {
      get() {
        return "amenagement_acces";
      },
      set(value) {
        this.cerfa.themes = value.join(",");
      },
    },
    surfacePlanningEquipment: {
      get() {
        if (this.cerfa.surfacePlanningEquipment == null) return [];
        else return this.cerfa.surfacePlanningEquipment.split(",");
      },
      set(value) {
        this.cerfa.surfacePlanningEquipment = value.join(",");
      },
    },
    networkConnection: {
      get() {
        if (this.cerfa.networkConnection == null) return [];
        else return this.cerfa.networkConnection.split(",");
      },
      set(value) {
        this.cerfa.networkConnection = value.join(",");
      },
    },
  },
  data() {
    return {
      options: [
        { text: "Oui", value: true },
        { text: "Non", value: false },
      ],

      natures: [
        { text: "Dépôt ou stationnement", value: "depot_stationnement" },
        { text: "Saillie ou Surplomb", value: "saillie_surplomb" },
        { text: "Aménagement d'accès", value: "amenagement_acces" },
        {
          text: "Pose de compteur / branchement aux réseaux",
          value: "pose_compteur",
        },
        { text: "Ouvrages divers", value: "ouvrage_divers" },
      ],
      works: [
        { text: "Station service", value: "station_service" },
        { text: "Renouvellement", value: "renouvellement" },
        { text: "Création", value: "creation" },
        { text: "Autres", value: "autres" },
      ],
      parking_extension: [
        { text: "Demande initiale", value: false },
        { text: "Prolongation", value: true },
      ],
      installations: [
        { text: "Travaux sur ouvrages existants", value: false },
        { text: "Installation nouvelle", value: true },
      ],
      fosse: [
        { text: "Avec franchissement de fossé", value: true },
        { text: "Sans franchissement de fossé", value: false },
      ],
    };
  },
};
</script>
